export const delay = (delay) => {
  return new Promise((res) => setTimeout(res, delay));
};
